import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 1.3H5.333a2.667 2.667 0 0 0-2.666 2.667v8a2.667 2.667 0 0 0 2.666 2.666H12a1.334 1.334 0 0 0 1.333-1.333V2.633A1.334 1.334 0 0 0 12 1.3M4 3.967a1.333 1.333 0 0 1 1.333-1.334H12V9.3H5.333c-.47.002-.93.131-1.333.373zM5.333 13.3a1.333 1.333 0 1 1 0-2.667H12V13.3zm1.334-8h2.666a.667.667 0 0 0 0-1.333H6.667a.667.667 0 1 0 0 1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })